import React from 'react';

import { Modal, ModalBody, ModalFooter, ModalHeader } from '@adeccoux/tag-ds';
import { isCurrentLanguageGreek } from '@helpers/utils';

interface ModalProps {
  isOpen: boolean;
  title: string;
  content: string;
  onConfirm?: () => any;
  onClose?: () => any;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const ModalPrompt: React.FC<ModalProps> = ({
  isOpen,
  title,
  content,
  onConfirm,
  onClose,
  confirmLabel,
  cancelLabel,
}) => {
  return (
    <div className="tag-ds">
      <Modal onClose={onClose} open={isOpen} renderAsPortal={true}>
        <ModalHeader>
          <h4>{title}</h4>
        </ModalHeader>
        <ModalBody>{content} </ModalBody>
        <ModalFooter>
          <button
            className="button-primary"
            onClick={onConfirm}
            style={{ textTransform: `${isCurrentLanguageGreek() ? 'none' : 'uppercase'}` }}
          >
            {confirmLabel}
          </button>
          <button
            className="button-secondary"
            onClick={onClose}
            style={{ textTransform: `${isCurrentLanguageGreek() ? 'none' : 'uppercase'}` }}
          >
            {cancelLabel}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
